import React from "react";
import styled from "styled-components";
import get from 'lodash/get';
const Container = styled.div `
  background-color: ${props => props.background};
  height: 5em;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;
const Social = styled.a `
  margin: 1em 2em;
`;
const SocialImg = styled.img `
  height: 2em;
  width: 2em;
`;
export default ({ instagram, facebook, twitter, theme }) => {
    return (React.createElement(Container, { background: get(theme, 'color.background') },
        facebook &&
            React.createElement(Social, { key: facebook, href: facebook, target: "blank" },
                React.createElement(SocialImg, { src: `/img/icon/facebook.svg` })),
        twitter &&
            React.createElement(Social, { key: twitter, href: twitter, target: "blank" },
                React.createElement(SocialImg, { src: `/img/icon/twitter.svg` })),
        instagram &&
            React.createElement(Social, { key: instagram, href: instagram, target: "blank" },
                React.createElement(SocialImg, { src: `/img/icon/instagram.svg` }))));
};
